import type { JSX } from 'react';
import { USER_ROLES } from '@/lib/auth';
import { AdminDashboard } from '@/routes/admin/AdminDashboard';
import { ManagerOperations } from '@/routes/manager/ManagerOperations';
import { ErrorState } from '@/components/feedback/ErrorState';
import { useDashboardUser } from '@/routes/dashboard/DashboardRouter';

export function DashboardHome(): JSX.Element {
  const user = useDashboardUser();

  if (user.role === USER_ROLES.administrator) {
    return <AdminDashboard />;
  }

  if (user.role === USER_ROLES.manager) {
    return <ManagerOperations />;
  }

  return (
    <ErrorState
      title="Role not supported"
      description="Tenant dashboards and request tools are no longer available for this account."
    />
  );
}
